import React from 'react';

const EventContext = React.createContext({
    event: {},
    eventId: "",
    clearEvent: () => {},
    setEvent: (selected) => {}
});

export default EventContext;
